<template>
    <span class="m-rate" :style="{fontSize: size, color: color}">
        <a href="javascript:;" v-for="item in ~~count"
           :class="index >= item ? 'rate-active' : ''"
           :style="{color: index >= item ? activeColor : color, paddingRight: padding}"
           @click="!readonly && choose(item)"
        ></a>
        <span class="rate-text" v-if="!!str" v-html="str"></span>
    </span>
</template>

<script type="text/babel">
  import {isColor} from '../assets/utils';

  export default {
    name: 'rate',
    data() {
      return {
        index: 0,
        str: ''
      };
    },
    props: {
      count: {
        validator(val) {
          return /^(([1-9]\d*)|0)$/.test(val);
        },
        default: 5
      },
      size: {
        validator(value) {
          return /^(\.|\d+\.)?\d+(px|rem)$/.test(value);
        },
        default: '.5rem'
      },
      color: {
        validator(value) {
          let flag = true;
          if (!value) {
            flag = true;
          } else {
            flag = isColor(value);
          }
          return flag;
        },
        default: '#CCC'
      },
      activeColor: {
        validator(value) {
          let flag = true;
          if (!value) {
            flag = true;
          } else {
            flag = isColor(value);
          }
          return flag;
        },
        default: '#FF5D50'
      },
      value: {
        validator(val) {
          return /^(([1-9]\d*)|0)$/.test(val);
        }
      },
      showText: {
        type: Array
      },
      readonly: {
        type: Boolean,
        default: false
      },
      padding: {
        validator(value) {
          return /^(\.|\d+\.)?\d+(px|rem)$/.test(value);
        },
        default: '.06rem'
      }
    },
    methods: {
      choose(index) {
        this.index = index;
        this.$emit('input', index);
        const isshowText = !!this.showText;
        if (isshowText) {
          this.str = (this.showText[index - 1] || '').replace('$', index);
        }
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.choose(this.value);
      });
    }
  };
</script>

<style lang="less">
  @import "../assets/base.less";

  .m-rate {
    display: flex;
    align-items: center;
    a {
      &:after {
        content: '\E630';
        font-family: @iconfont-inlay;
        font-size: inherit;
        color: inherit;
      }
      &.rate-active:after {
        content: '\E631';
      }
    }
    .rate-text {
      color: #657180;
      margin-left: .1rem;
      font-size: .3rem;
    }
  }
</style>



// WEBPACK FOOTER //
// Rate.vue?9e211f50